import { useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { trackLogin, AuthMethod } from '../lib/analyticsEvents'
import { recordAfterOAuth } from '../lib/acquisition'
import LoadingSpinner from '../components/LoadingSpinner'
import styles from './AuthCallback.module.css'

export default function AuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  const handled = useRef(false)

  const params = new URLSearchParams(location.search)
  const hashParams = new URLSearchParams(location.hash.slice(1))
  const type = params.get('type') ?? hashParams.get('type')

  useEffect(() => {
    if (handled.current) return
    handled.current = true

    // Reset links land here when Site URL is the fallback: detectSessionInUrl has set the recovery session, so forward to /reset-password.
    if (type === 'recovery') {
      navigate('/reset-password', { replace: true })
      return
    }

    const searchParams = new URLSearchParams(location.search)
    const code = searchParams.get('code')

    let authSubscription = null
    let timer = null

    if (code) {
      supabase.auth.exchangeCodeForSession(code)
        .then(({ data, error }) => {
          if (error) navigate('/login')
          else {
            recordAfterOAuth(data?.user, (meta) => supabase.auth.updateUser({ data: meta })).catch(() => {})
            // The PKCE code exchange on web is the Google OAuth return leg.
            trackLogin(AuthMethod.GOOGLE)
            navigate('/today', { state: { authType: type, postAuth: true } })
          }
        })
    } else {
      const { data } = supabase.auth.onAuthStateChange((event) => {
        if (event === 'SIGNED_IN') {
          data.subscription.unsubscribe()
          navigate('/today', { state: { authType: type, postAuth: true } })
        }
      })
      authSubscription = data.subscription

      timer = setTimeout(() => navigate('/login'), 5000)
    }

    return () => {
      if (authSubscription) authSubscription.unsubscribe()
      if (timer) clearTimeout(timer)
    }
  }, [navigate, type, location.search])

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <LoadingSpinner />
        <p className={styles.body}>Signing you in...</p>
      </div>
    </div>
  )
}
